import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  return token ? children : <Navigate to="/login" />;
};

export const AdminRoute = ({ element }) => {
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("userRole"); 
   // admin, super, vendor
  return token && (role === "admin" || role === "super")
    ? element
    : <Navigate to="/unauthorized" />;
};

export const VendorRoute = ({ element }) => {
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("userRole");
  return token && role === "vendor"
    ? element
    : <Navigate to="/unauthorized" />;
};